import React, { useState } from 'react';
import { cn } from '@/lib/utils';

const LangDropdownMenu = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    return (
        <div className="dropdown-group relative">
            <button className="dropdown-btn flex items-center gap-2 h-9 px-3 rounded-lg bg-primary-light" onClick={() => setDropdownOpen(!dropdownOpen)}>
                <img src={'https://demo.foodscan.xyz/storage/23/english.png'} alt="flag" className="w-4 h-4 rounded-full" />
                <span className="hidden md:block whitespace-nowrap text-xs font-medium capitalize text-heading">English</span>
            </button>
            <ul className={cn('p-2 min-w-[180px] rounded-lg shadow-xl absolute top-14 right-0 z-10 border border-gray-200 bg-white dropdown-list', dropdownOpen ? 'active' : '')}>
                <li className="flex items-center gap-2 py-1.5 px-2.5 rounded-md cursor-pointer hover:bg-gray-100">
                    <img src={'https://demo.foodscan.xyz/storage/23/english.png'} alt="flag" className="w-4 h-4 rounded-full" />
                    <span className="text-heading capitalize text-sm">English</span>
                </li>
                <li className="flex items-center gap-2 py-1.5 px-2.5 rounded-md cursor-pointer hover:bg-gray-100">
                    <img src={'https://demo.foodscan.xyz/storage/23/english.png'} alt="flag" className="w-4 h-4 rounded-full" />
                    <span className="text-heading capitalize text-sm">Bangla</span>
                </li>
                <li className="flex items-center gap-2 py-1.5 px-2.5 rounded-md cursor-pointer hover:bg-gray-100">
                    <img src={'https://demo.foodscan.xyz/storage/25/german.png'} alt="flag" className="w-4 h-4 rounded-full" />
                    <span className="text-heading capitalize text-sm">German</span>
                </li>
            </ul>
        </div>
    );
};

export default LangDropdownMenu;
